import { FaLinkedin } from 'react-icons/fa';
import { RiMailSendLine } from 'react-icons/ri';
import { motion } from 'framer-motion';

const Link = {
textDecoration: 'none',
color: 'blue'
}

const Text = {
     fontSize: '.75em',
     fontWeight: 'bold'
}

const Connect = () => (
     <>
     <a className="linkedIn" href="https://www.linkedin.com/in/davidbenhorin/" target="_blank">

          <motion.h3 style={{color: 'black'}}
          whileHover={{
               scale: 1.2,
               transition: {
                    duration: .3
               },
          }}
          >Let's Connect! <FaLinkedin style={{color: "cornflowerblue", fontSize: "1em" }}/></motion.h3>
          <a style= {Link} href="mailto:david.ben.horin@spreadyourenthusiasm.com"><RiMailSendLine /><span style={Text}> We can also email! </span><RiMailSendLine /></a>
          </a>

       

          </>
     );  

     export default Connect;
 